<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="closeStatusMessagePopup()"
></ml-status-message-popup-v2>
<div class="container gap-override">
  <form novalidate (submit)="$event.preventDefault();">
    <ml-card-container [title]="'application.demat-delivery.title' | translate" [icon]="'digital-signature'">
      <ml-information-card [text]="'application.demat-delivery.information' | translate" />
      @if (!isVadDelivery()) {
      <div class="delivery-mode">
        <ml-yes-no-signal-input
          class="select"
          [formField]="dematDeliveryForm.distanceSignature"
          [id]="'dematDeliveryField1'"
          [label]="'application.demat-delivery.fields.delivery-mode' | translate"
          [yesNoTranslations]="deliveryModeTranslations$ | async"
          [reverse]="true"
        />
      </div>
      }
      <div class="content">
        <div class="characteristics">
          <h2>{{ 'application.demat-delivery.vehicle-features' | translate }}</h2>
          @if (!dematDeliveryForm.registrationNumber().hidden()) {
            <div class="registration-container">
              <ml-text-signal-input
                [formField]="dematDeliveryForm.registrationNumber"
                mlToUppercaseSignal
                [mlLiveControlRegexSignal]="immatRegex"
                [toggleValidationIcon]="true"
                [label]="
                  `application.demat-delivery.fields.registration-number${dematDeliveryContract()?.usedVehicle ? '' : '-optional'}`
                    | translate
                "
                [id]="'dematDeliveryField2'"
                [placeholder]="'application.demat-delivery.placeholders.registration-number' | translate"
              />
              @if (registrationNumberHint()) {
                <ml-infobubble
                  [chevron]="chevronPosition.TOP_LEFT"
                  [iconName]="'information-lamp'"
                  [content]="registrationNumberHint() | translate"
                ></ml-infobubble>
              }
            </div>
          }
          @if (isFetchVehicleLoading()) {
            <ml-custom-line-skeleton
              class="skeleton grow-flex-1"
              [label]="'application.demat-delivery.fields.serial-number' | translate"
              [customHeight]="5.4"
            ></ml-custom-line-skeleton>
          } @else {
            <ml-text-signal-input
              [formField]="dematDeliveryForm.serialNumber"
              mlToUppercaseSignal
              [maxlength]="17"
              [mlControlRegexSignal]="vinRegex"
              [toggleValidationIcon]="true"
              [label]="'application.demat-delivery.fields.serial-number' | translate"
              [id]="'dematDeliveryField3'"
              [placeholder]="'application.demat-delivery.placeholders.serial-number' | translate"
            />
          }
        </div>
        <div class="consent">
          <h2>{{ dematDeliveryContract()?.holderName }}</h2>
          <ml-email-signal-input
            [label]="'application.demat-delivery.fields.email' | translate"
            [id]="'dematDeliveryField4'"
            [placeholder]="'application.demat-delivery.placeholders.email' | translate"
            [formField]="dematDeliveryForm.emailAddress"
            [toggleValidationIcon]="true"
          />
          <ml-mobile-phone-signal-input
            [label]="'application.demat-delivery.fields.mobile-phone' | translate"
            [id]="'dematDeliveryField5'"
            [placeholder]="'application.demat-delivery.placeholders.mobile-phone' | translate"
            [formField]="dematDeliveryForm.mobilePhoneNumber"
            [toggleValidationIcon]="true"
            [width]="enumWidth.LARGE"
          />
        </div>
      </div>
      <div class="footer">
        <div class="information">{{ 'application.demat-delivery.bottom-info' | translate }}</div>
        <ml-loading-button
          [label]="'application.demat-delivery.button' | translate"
          [disabled]="dematDeliveryForm().invalid()"
          [loading]="isDeliveryLoading()"
          (event)="submit()"
        />
      </div>
    </ml-card-container>
  </form>
</div>
